
import _ from "lodash";

const FORM_VALUES = ["firstName", "lastName", "email", "address", "state", "phoneNumber", "postalCode", "region", "newsletter", "promotions"]

// class definition
export class FormSubmissionManager {

  constructor(localizationService,leadGenerationService, profileManager) {
    this._localizationService = localizationService;
    this._leadGenerationService = leadGenerationService;
    this._profileManager = profileManager;
  }

/**
form {firstName, lastName, email, address, phoneNumber, postalCode, region, newsletter, promotions}
*/
  async submitLeadGeneration(payload) {

    try {
      let status = await this._leadGenerationService.createLead(payload, this._profileManager.playerID);
      return status;
    } catch (e) {
      throw e;
    }
  }
}


// WEBPACK FOOTER //
// ./src/managers/FormSubmissionManager.js